import React from 'react';
export function RefundPolicy() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-slate-50" data-id="element-419">
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-420">
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8" data-id="element-421">
          Refund Policy
        </h1>

        <div className="bg-white rounded-2xl shadow-lg p-8 space-y-6" data-id="element-422">
          <div data-id="element-423">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-424">
              Our Refund Commitment
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-425">
              At Domisafe, we strive to provide excellent service and value. Our
              refund policy is designed to be fair and transparent, reflecting
              the nature of our subscription-based software service.
            </p>
          </div>

          <div data-id="element-426">
            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-427">
              0–14 Days: Full Refund if Unused
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-428">
              If you cancel within 14 days of your initial purchase and have not
              used the service, you are entitled to a full refund. "Unused"
              means you have not logged into the platform or accessed any
              features.
            </p>
            <p className="text-slate-600 leading-relaxed" data-id="element-429">
              To request a refund during this period, contact our support team
              at{' '}
              <a href="mailto:srijangurung098@gmail.com" className="text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-430">
                srijangurung098@gmail.com
              </a>{' '}
              with your account details. We will process your refund within 5–10
              working days.
            </p>
          </div>

          <div data-id="element-431">
            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-432">
              15–28 Days: Partial Refund at Discretion
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-433">
              If you request a refund between 15 and 28 days after your initial
              purchase, we may offer a partial refund at our discretion. The
              amount refunded will depend on factors such as:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600 mb-4" data-id="element-434">
              <li data-id="element-435">The extent to which you have used the service</li>
              <li data-id="element-436">The reason for your cancellation</li>
              <li data-id="element-437">Whether any exceptional circumstances apply</li>
            </ul>
            <p className="text-slate-600 leading-relaxed" data-id="element-438">
              Partial refunds are assessed on a case-by-case basis. Please
              contact our team to discuss your situation, and we will work with
              you to find a fair resolution.
            </p>
          </div>

          <div data-id="element-439">
            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-440">
              After 28 Days: Refunds Not Available
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-441">
              Refunds are not available for cancellations made more than 28 days
              after your initial purchase. This policy reflects the ongoing
              costs of providing and maintaining our service.
            </p>
            <p className="text-slate-600 leading-relaxed" data-id="element-442">
              If you cancel after 28 days, your subscription will remain active
              until the end of your current billing period, and you will not be
              charged for subsequent months. However, no refund will be issued
              for the current or previous billing cycles.
            </p>
          </div>

          <div data-id="element-443">
            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-444">
              Refund Process
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-445">
              All refunds are returned to the original payment method used at
              the time of purchase. Depending on your bank or card provider, it
              may take 5–10 working days for the refund to appear in your
              account.
            </p>
            <p className="text-slate-600 leading-relaxed" data-id="element-446">
              You will receive a confirmation email once your refund has been
              processed. If you do not see the refund within 10 working days,
              please contact your bank or card provider, as processing times can
              vary.
            </p>
          </div>

          <div data-id="element-447">
            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-448">
              Exceptional Circumstances
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-449">
              We understand that exceptional circumstances can arise. If you
              believe your situation warrants special consideration (for
              example, technical issues preventing service use, or billing
              errors), please contact our support team. We will review your case
              individually and work with you to find a fair outcome.
            </p>
          </div>

          <div data-id="element-450">
            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-451">
              How to Request a Refund
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-452">
              To request a refund, email our support team at{' '}
              <a href="mailto:srijangurung098@gmail.com" className="text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-453">
                srijangurung098@gmail.com
              </a>{' '}
              with the following information:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600" data-id="element-454">
              <li data-id="element-455">Your account email address</li>
              <li data-id="element-456">The date of your purchase</li>
              <li data-id="element-457">The reason for your refund request</li>
              <li data-id="element-458">Any relevant details about your usage or circumstances</li>
            </ul>
          </div>

          <div className="bg-slate-50 rounded-lg p-6 mt-8" data-id="element-459">
            <p className="text-slate-700 leading-relaxed" data-id="element-460">
              <span className="font-semibold" data-id="element-461">Questions about refunds?</span>{' '}
              Our team is here to help. Contact us at{' '}
              <a href="mailto:srijangurung098@gmail.com" className="text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-462">
                srijangurung098@gmail.com
              </a>{' '}
              and we'll respond within one working day.
            </p>
          </div>
        </div>
      </section>
    </div>;
}